import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const doorstop = {
  title: "DoorStop — materials to your door",
  description:
    "Order hardware and building supplies for the site, from your phone. Browse the catalog, send an order, and track delivery to your job site.",
  url: "https://instantdigits.com/doorstop",
  image: "https://instantdigits.com/doorstop-og.png",
  siteName: "DoorStop",
};

const instantDigits = {
  title: "Your digital future!",
  description:
    "Leading custom software development company in Toronto, Ontario. We build AI-powered enterprise solutions, custom ERP systems, RFID platforms, and intelligent business apps for Canadian businesses.",
  url: "https://instantdigits.com",
  image: "https://instantdigits.com/banner.png",
  siteName: "Instant Digits",
};

const Seo = () => {
  const { pathname } = useLocation();
  const seo = pathname.startsWith("/doorstop") ? doorstop : instantDigits;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:site_name" content={seo.siteName} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <link rel="canonical" href={seo.url} />
    </Helmet>
  );
};

export default Seo;
